// ─── Ingredient type constants ───────────────────────────────────────────────

export const INGREDIENT_TYPE_EMOJIS: Record<string, string> = {
  Meat: "🥩",
  Poultry: "🍗",
  Fish: "🐟",
  Vegetables: "🥬",
  Fruits: "🍋",
  Dairy: "🥛",
  "Deli/Cheese": "🧀",
  "Pantry/Canned": "🥫",
  Condiments: "🧂",
  Other: "📦",
};

export const INGREDIENT_TYPE_LABELS: Record<string, string> = {
  Meat: "Carnes",
  Poultry: "Aves",
  Fish: "Pescados",
  Vegetables: "Verduras",
  Fruits: "Frutas",
  Dairy: "Lácteos",
  "Deli/Cheese": "Fiambres / Quesos",
  "Pantry/Canned": "Almacén / Enlatados",
  Condiments: "Condimentos",
  Other: "Otros",
};

export const INGREDIENT_TYPE_ORDER = [
  "Meat",
  "Poultry",
  "Fish",
  "Vegetables",
  "Fruits",
  "Dairy",
  "Deli/Cheese",
  "Pantry/Canned",
  "Condiments",
  "Other",
];

// ─── External tools ──────────────────────────────────────────────────────────

const GANTT_CREATOR_BASE = "https://francofrizzo.github.io/gantt-creator";

export function ganttCreatorUrl(data?: string): string {
  if (!data) return GANTT_CREATOR_BASE;
  const encoded = btoa(unescape(encodeURIComponent(data)));
  return `${GANTT_CREATOR_BASE}/#data=${encoded}`;
}
